import { FC } from 'react';
import { IconPath, IconSVG, IconSVGComponentProps } from '../IconComponent';

export const Firearms: FC<IconSVGComponentProps> = ({
    pathProps,
    ...props
}) => {
    return (
        <IconSVG strokeWidth={0} {...props}>
            <IconPath
                fill="currentColor"
                fillRule="evenodd"
                d="M3.272 10.58V7.5h17v3h-9.65a2.5 2.5 0 0 0-2.412 1.84l-1.986 7.262-3.61-.987 1.676-6.127a1.575 1.575 0 0 0-1.018-1.907Zm4.267 9.9a1 1 0 0 1-1.228.7l-4.574-1.25a1 1 0 0 1-.701-1.229l1.427-5.22.004-.013.305-1.117.07-.258a.073.073 0 0 0-.07-.093 1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-7.135l-.501 1.755a2.75 2.75 0 0 1-2.645 1.995H8.832L7.54 20.48Zm1.704-6.23h1.248a1.25 1.25 0 0 0 1.202-.907L12.077 12h-1.456a1 1 0 0 0-.965.736l-.413 1.514Z"
                clipRule="evenodd"
                {...pathProps}
            />
        </IconSVG>
    );
};
